import Vue from 'vue';
require('moment/locale/ru')
Vue.use(require('vue-moment'));